export default {"src":"/_next/static/media/header-white-logo.247978cc.svg","height":32,"width":371,"blurWidth":0,"blurHeight":0};